/**
 * Кастомная иконка «Сердце» — outline вариант со stroke
 *
 * stroke="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function HeartOutlineIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M22.2499 9.39154C22.2389 6.59389 20.7647 3.9629 17.8581 3.0307C15.8623 2.38948 13.6883 2.74606 12 5.15936C10.3117 2.74606 8.13766 2.38948 6.14187 3.0307C3.23503 3.963 1.76077 6.5945 1.7501 9.3925C1.72321 14.9568 7.38653 19.2149 11.9986 21.25L12 21.2493L12.0014 21.25C16.6137 19.2148 22.2775 14.9564 22.2499 9.39154Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="square"
      />
    </svg>
  );
}
